import type { FC } from "react";
import React from "react";

import type { EventEmitterCatalog } from "~/clientState/providers/generic/PrimeEventManager/events/eventCatalog";
import type {
  ExternalEventEmitter,
  PrimeEventManagerProviderType,
  PrimeEventData,
} from "~/clientState/providers/generic/PrimeEventManager/types/PrimeEventManagerProviderType";
import PrimeEventEmitterContext from "./contexts";

const PrimeEventManagerProvider: FC<PrimeEventManagerProviderType> = ({
  externalEventEmitter,
  children,
}) => {
  const emptyEventEmitterHook: ExternalEventEmitter =
    (id: EventEmitterCatalog) => (data: PrimeEventData) => {
      // Should throw an exception or log
    };

  // There should be a PrimeEventReceiverContext that would manage the state
  // of the events received to be re-used by all components and avoid
  // new instance of hooks and to prop drill the event received to all components.
  // A refactor is needed.
  return (
    <PrimeEventEmitterContext.Provider
      value={{
        eventEmitterHook: externalEventEmitter ?? emptyEventEmitterHook,
      }}
    >
      {children}
    </PrimeEventEmitterContext.Provider>
  );
};

export default PrimeEventManagerProvider;
